import React from 'react';
import useEditClientDetail from './hooks';
import { firstLetterCapitalized } from '../../../../../components/atoms/func';
import RoutesClientForms from '../../client';
import BottomButton from '../../utils/BottomButton';
import AddHeader from '../../../../../components/layout/header/add';

function EditClientDetail() {
  const {
    resData, routeId, clientId, formik, isLoading,
  } = useEditClientDetail();
  return (
    <div>
      <AddHeader
        primary={{ route: '/routes', title: 'Routes' }}
        secondary={{ route: `/routes/route/${routeId}`, title: firstLetterCapitalized(resData?.name) }}
        title="Edit Client Detail"
      />
      <RoutesClientForms id={undefined} formik={formik} client={clientId ?? ''} index={1} edit />
      <BottomButton loading={isLoading} />
    </div>
  );
}

export default EditClientDetail;
